import React, { useEffect } from "react";
import { Link as ScrollLink } from "react-scroll";
import "./MobileMenu.css";

const MobileMenu = ({ isOpen, toggle }) => {
  // Prevent scrolling when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  return (
    <div 
      className={`mobile-menu ${isOpen ? "open" : ""}`}
      onClick={toggle} // Close when clicking the background
    >
      <div 
        className="mobile-menu-container"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking menu content
      >
        <div className="mobile-nav-items">
          <ScrollLink
            className="mobile-nav-item"
            to="projects"
            smooth={true}
            duration={500}
            onClick={toggle}
          >
            Projects
          </ScrollLink>
          
          <ScrollLink
            className="mobile-nav-item"
            to="about"
            smooth={true}
            duration={500}
            onClick={toggle}
          >
            About
          </ScrollLink>
          
          <ScrollLink
            className="mobile-nav-item"
            to="contact"
            smooth={true}
            duration={500}
            onClick={toggle}
          >
            Contact
          </ScrollLink>
          
          <a
            className="mobile-nav-item"
            href="https://blog.dibyanjaya.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Blog
          </a>
        </div>
        
        <div className="mobile-menu-footer">
          <a
            className="resume-button mobile"
            href="/Dibyanjaya_Panda.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download Resume
          </a>
          
          <div className="social-links">
            <a href="https://github.com/yourusername" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
              </svg>
            </a>
            
            <a href="https://linkedin.com/in/dibyanjaya-panda-815819299" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                <rect x="2" y="9" width="4" height="12"></rect>
                <circle cx="4" cy="4" r="2"></circle>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;